<!--
 * @Author: your name
 * @Date: 2022-04-20 16:29:29
 * @LastEditTime: 2022-04-28 14:07:15
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /my-activation/src/addAdress/index.vue
-->
<template>
  <div class="myorder">
    <div
      class="order_box"
      v-for="(item, idx) in orderList"
      :key="idx"
      v-if="item.status == 3 || item.status == 9"
    >
      <div class="order_head">
        <div class="head_le">
          <img
            :src="
              shopData.iconUrl
                ? shopData.iconUrl
                : '../../static/image/bgimg.png'
            "
            alt=""
          />
          <span>{{ shopData.name }}</span>
        </div>
        <div class="head_ri" :class="item.status == 9 ? 'gray' : ''">
          {{ exchangeStatus(item.status) }}
        </div>
      </div>
      <div class="order_center" @click="handleToDetail(item)">
        <img
          v-for="(it, idx) in item.goodsList"
          :src="it.goodsImageUrl"
          :key="idx"
        />
        <span>共{{ item.goodsList.length }}件</span>
      </div>
      <div class="footers">
        <div class="footers_time">
          下单时间：{{ moment(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}
        </div>
        <div class="footer_tot">
          合计 <span class="footer_money">￥{{ item.amount }}</span>
        </div>
      </div>
      <a :href="`tel:${shopData.tel}`" class="callShop">联系商家</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Detail",
  data() {
    return {
      openID: localStorage.getItem("code"),
      saleTempInfo: {},
      orderList: [],
      shopData: JSON.parse(localStorage.getItem("shopList"))[0]
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // 订单状态
    exchangeStatus(status) {
      let data = [
        "",
        "待付款",
        "待支付",
        "已付款",
        "退款中",
        "已退款",
        "待发货",
        "已发货",
        "已取消",
        "已完成"
      ];
      return data[status];
    },
    getData() {
      const shopID = localStorage.getItem("shopID");
      // 商品信息
      this.RequestMall(
        "GET",
        `h5/mall/goods/all?shopID=${shopID}&openID=${this.openID}`,
        {},
        res => {
          const { saleTempInfo } = res.data.data;
          this.saleTempInfo = saleTempInfo;
          this.RequestMall(
            "GET",
            // &saleTempID=${saleTempInfo.id}&shopID=${shopID}
            `h5/mall/order/all?openID=${this.openID}&saleTempID=${saleTempInfo.id}&shopID=${shopID}`,
            {},
            r => {
              this.orderList = r.data.data.result;
              console.log(r, "orderlisttttttttttttt");
            }
          );
        },
        err => console.log(err)
      );
    },
    handleToDetail(item) {
      window.location.href = `/#/OrderDetail?detail=${encodeURIComponent(
        JSON.stringify(item)
      )}`;
    }
  }
};
</script>
<style scoped>
.myorder {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  -webkit-text-size-adjust: none;
}
.order_box {
  width: 93.2%;
  height: 139px;
  background: #ffffff;
  margin: 8px 8px 0 8px;
  border-radius: 3px;
  padding: 12px 8px;
  box-sizing: border-box;
  position: relative;
}
.order_head {
  display: flex;
  justify-content: space-between;
  padding-bottom: 5px;
  border-bottom: solid 1px #e0e0e0;
}
.head_le img {
  width: 14px;
  height: 14px;
  vertical-align: top;
}
.head_le span {
  font-size: 11px;
  font-weight: 500;
  color: #212121;
  display: inline-block;
  margin-left: 5px;
}
.head_ri {
  font-size: 10px;
  color: #ffa516;
}
.order_center {
  width: 93%;
  overflow-x: scroll;
  white-space: nowrap;
  margin-top: 8px;
}
.order_center img {
  width: 50px;
  height: 39px;
  margin-left: 6px;
  border-radius: 3px;
}
.order_center span {
  width: 8px;
  height: 40px;
  position: absolute;
  right: 8px;
  background: #ffffff;
  top: 45px;
  white-space: pre-wrap;
  text-align: center;
  font-size: 8px;
  color: #757575;
}
.footers {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
}
.footers_time {
  font-size: 8px;
  color: #757575;
  margin-top: 4px;
}
.footer_tot {
  font-size: 8px;
  color: #757575;
}
.footer_money {
  font-size: 11px;
  font-weight: bold;
  color: #212121;
}
.callShop {
  width: 50px;
  height: 17px;
  line-height: 17px;
  text-align: center;
  background: rgba(238, 238, 238, 0.39);
  opacity: 1;
  border-radius: 10px;
  color: #757575;
  position: absolute;
  right: 12px;
  bottom: 10px;
  text-decoration: none;
}
.gray {
  color: #757575;
}
</style>



// WEBPACK FOOTER //
// src/myOrder/index.vue